<template>
  <portal to="body">
    <transition name="drawer-fade">
      <div
        v-if="isVisible"
        class="fixed top-0 left-0 right-0 bottom-0"
        :style="{ zIndex: zIndex }"
        @click="handleOverlayClick"
      >
        <div
          class="fixed top-0 left-0 right-0 bottom-0 bg-black opacity-75"
          :style="{ zIndex: -1 }"
        ></div>

        <div
          class="drawer-container fixed top-0 bottom-0 overflow-auto bg-white shadow-lg transition-all duration-300 ease-in-out"
          :class="[drawerSideClass, drawerWidthClass, drawerPaddingClass, drawerHiddenClass]"
          :style="drawerInlineStyle"
          @click.stop
        >
          <div
            v-if="hasHeader"
            class="flex items-center"
            :class="headerClass"
          >
            <button type="button" class="focus:outline-none" @click="handleClose">
              <Icon icon-name="BackIcon" />
            </button>
            <div class="ml-2 text-base font-semibold text-gray-600">
              {{ title }}
            </div>
          </div>

          <div
            v-if="hasHeader"
            class="mt-3 h-px bg-white"
            style="box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 3px 0 rgba(0, 0, 0, 0.10);"
          ></div>

          <slot name="main-content">
            <div class="p-4 text-sm text-gray-600">
              This is the content of the drawer
            </div>
          </slot>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
import Icon from "./Icon.vue";

const TRANSITION_DELAY = 300;

export default {
  name: "AppDrawer",
  components: {
    Icon
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    isRightDrawer: {
      type: Boolean,
      default: true
    },
    drawerHeaderStyle: {
      type: String,
      default: ""
    },
    drawerWidth: {
      type: String,
      default: "sm:w-1/2"
    },
    drawerPadding: {
      type: String,
      default: "p-6"
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      isVisible: this.isDrawerOpen
    };
  },
  computed: {
    hasHeader() {
      return this.title && this.title.trim() !== "";
    },
    drawerWidthClass() {
      return this.drawerWidth || "";
    },
    drawerPaddingClass() {
      return this.drawerPadding || "";
    },
    drawerSideClass() {
      return this.isRightDrawer ? "right-0" : "left-0";
    },
    drawerHiddenClass() {
      if (this.isDrawerOpen) {
        return this.isRightDrawer ? "translate-x-0" : "-translate-x-0";
      }

      return this.isRightDrawer ? "translate-x-full" : "-translate-x-full";
    },
    headerClass() {
      return this.drawerHeaderStyle ? this.drawerHeaderStyle : "py-3 px-6";
    },
    drawerInlineStyle() {
      const side = this.isRightDrawer ? "right" : "left";

      return {
        [side]: this.isDrawerOpen ? "0" : undefined,
        transform: this.isDrawerOpen ? "translateX(0)" : this.isRightDrawer ? "translateX(100%)" : "translateX(-100%)"
      };
    }
  },
  watch: {
    isDrawerOpen(value) {
      if (value) {
        this.isVisible = true;
      } else {
        setTimeout(() => {
          this.isVisible = false;
        }, TRANSITION_DELAY);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("close-drawer");
    },
    handleOverlayClick(event) {
      if (event.target === event.currentTarget && this.closeOnOverlayClick) {
        this.handleClose();
      }
    }
  }
};
</script>

<style scoped>
.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s ease;
}

.drawer-fade-enter,
.drawer-fade-leave-to {
  opacity: 0;
}

.drawer-container {
  min-width: 18rem;
}

.translate-x-full {
  transform: translateX(100%);
}

.-translate-x-full {
  transform: translateX(-100%);
}

.translate-x-0 {
  transform: translateX(0);
}

.-translate-x-0 {
  transform: translateX(0);
}
</style>
